<template>
  <el-dialog
    v-if="visible"
    :visible.sync="visible"
    title="图片裁剪"
    width="800px"
    :append-to-body="true"
  >
    <div class="container">
      <div class="cropper">
        <img id="image" :src="img" />
      </div>
      <div class="preview">
        <el-form>
          <el-form-item>
            <el-input
              type="number"
              v-model="options.width"
              :disabled="options.disabled"
              @change="setCropBox"
            >
              <template slot="prepend">宽度</template>
              <template slot="append">px</template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              type="number"
              v-model="options.height"
              :disabled="options.disabled"
              @change="setCropBox"
            >
              <template slot="prepend">高度</template>
              <template slot="append">px</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="thumb"></div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel()">取消</el-button>
      <el-button type="primary" @click="submit()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Cropper from 'cropperjs';
import lrz from 'lrz';
import request from '@/utils/request';
import 'cropperjs/dist/cropper.css';

export default {
  data() {
    return {
      visible: false,

      img: null,
      cropper: null,
      options: null,

      checkFileFunc: null, // 外部传入的文件类型检测
    };
  },
  mounted() {},
  methods: {
    /**
     * options:{
     * type: blob | base64 |submit| update
     * file: 文件对象
     * width 宽度
     * height 高度
     * disabled: 允许编辑宽高
     * }
     */
    show(options) {
      const { type, file, width, height, disabled, quality } = {
        width: 200,
        height: 200,
        disabled: false,
        checkSize: false,
        quality: 'high',
        ...options,
      };
      if (!file) {
        this.$message('获取图片文件失败');
      }
      this.options = { type, file, width, height, disabled, quality };

      const url = URL.createObjectURL(file.raw);
      this.img = url;
      this.visible = true;

      this.$nextTick(() => {
        const image = document.getElementById('image');
        this.cropper = new Cropper(image, {
          aspectRatio: width / height,
          width,
          height,
          preview: '.thumb',
          dragMode: 'none',
        });
      });
    },
    hide() {
      this.visible = false;
    },
    // 提交按钮操作
    submit() {
      if (this[this.options.type]) {
        this[this.options.type]();
      }
      this.$emit('submit');
      this.hide();
    },
    base64() {
      const { width, height, quality } = this.options;
      const afterImg = this.cropper
        .getCroppedCanvas({
          imageSmoothingQuality: quality,
          width,
          height,
        })
        .toDataURL('image/jpeg');
      this.$emit('base64', afterImg); // base64的图片格式
    },
    blob() {
      const { width, height, quality } = this.options;
      this.cropper
        .getCroppedCanvas({
          imageSmoothingQuality: quality,
          width,
          height,
        })
        .toBlob((e) => {
          this.$emit('blob', e); // 生成Blob的图片格式
        }, 'image/jpeg');
    },
    // 提交
    upload(url) {
      const { width, height, quality } = this.options;
      return new Promise((resolve) => {
        this.cropper
          .getCroppedCanvas({
            imageSmoothingQuality: quality,
            width,
            height,
          })
          .toBlob(async (blob) => {
            const formData = new FormData();
            const file = new File([blob], this.options.file.name, {
              type: blob.type,
            });
            // png不压缩
            if (blob.type.toLocaleLowerCase() !== 'image/png') {
              const rst = await lrz(file, { quality: 1 });
              // 处理成功会执行
              const zipFile = rst.file;
              if (this.checkFileFunc) {
                if (!this.checkFileFunc(zipFile)) return; // 验证图片
              }
              formData.append('file', zipFile);
            } else {
              formData.append('file', file);
            }

            if (this.checkFileFunc) {
              if (!this.checkFileFunc(file)) return; // 验证图片
            }
            resolve(
              request({
                url,
                data: formData,
                method: 'post',
                headers: {
                  authorization: `Bearer ${this.$store.getters.token}`,
                  'Content-Type': 'multipart/form-data',
                },
              }),
            );
          }, 'image/jpeg');
      });
    },
    cancel() {
      this.hide();
    },
    // 设置选框
    setCropBox() {
      const { width, height } = this.options;
      const options = this.cropper.getCropBoxData();
      this.cropper.setAspectRatio(width / height);
      this.cropper.setCropBoxData({ ...options, width, height });
    },
    // 设置检查文件函数
    setCheckFunc(fun) {
      this.checkFileFunc = fun;
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  display: block;
  max-width: 100%;
}
.container {
  display: flex;
  justify-content: space-between;
  .cropper {
    width: 500px;
    height: 400px;
    margin-right: 20px;
  }
  .preview {
    width: 250px;
  }
}

.thumb {
  width: 150px;
  height: 300px;
  max-height: 300px;
  overflow: hidden;
  border: 1px solid #dcdfe6;
}
.el-input .suffix {
  line-height: 30px;
}
</style>
